import React, { useState, useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { useParams } from "react-router-dom";
import { DiscussionEmbed } from "disqus-react";
import { fetchPodcasts } from "../components/contentfulFiles";
import { Helmet } from "react-helmet";
import "../styles/podcastpage.css";

const Podcastcontent = () => {
  const { titleSlug } = useParams();
  const [podcast, setPodcast] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPodcasts().then((data) => {
      const match = data.find(
        (p) =>
          p.fields.title.toLowerCase().replace(/[\s_]+/g, "-") === titleSlug
      );
      setPodcast(match || null);
      setLoading(false);
    });
  }, [titleSlug]);

  if (loading) {
    return (
      <div className="podcast-detail">
        <Navbar />
        <main className="podcast-loading">
          <div className="podcast-loading-spinner"></div>
          <p>Loading podcast...</p>
        </main>
        <Footer />
      </div>
    );
  }

  if (!podcast) {
    return (
      <div className="podcast-detail">
        <Navbar />
        <main className="podcast-loading">
          <p>Podcast not found.</p>
        </main>
        <Footer />
      </div>
    );
  }

  const videoId = podcast.fields.pageUrl.split("v=")[1];

  return (
    <div className="podcast-detail">
      <Helmet>
        <title>{podcast.fields.title} — CFNSDA Podcasts</title>
      </Helmet>
      <Navbar />
      <main className="podcast-detail-main">

        {/* Title */}
        <h1 className="podcast-detail-title">{podcast.fields.title}</h1>

        {/* Meta pills */}
        <div className="podcast-detail-meta">
          {podcast.fields.speaker && (
            <span className="podcast-detail-pill">{podcast.fields.speaker}</span>
          )}
          {podcast.fields.date && (
            <span className="podcast-detail-pill podcast-detail-pill-date">
              {podcast.fields.date}
            </span>
          )}
        </div>

        {/* Video embed */}
        <div className="podcast-video-wrap">
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${videoId}`}
            title={podcast.fields.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        {/* Disqus */}
        <div className="podcast-disqus-wrap">
          <h2 className="podcast-disqus-head">Discussion</h2>
          <DiscussionEmbed
            shortname="calvarypodcasts"
            config={{
              url: window.location.href,
              identifier: podcast.fields.id,
              title: podcast.fields.title,
              language: "en_US",
            }}
          />
        </div>

      </main>
      <Footer />
    </div>
  );
};

export default Podcastcontent;